import FileUpload from "@/components/FileUpload";
import Select from "@/components/Select";
import Switch from "@/components/Switch";
import TextField from "@/components/TextField";
import {
  ACCEPTED_PERSON_PROFILE_DOCUMENT_FILES,
  filenameStem,
  formCategoryOptions,
  isMembershipServicesPrivateCategory,
  type PersonProfileDocumentCategory,
  type PersonProfileDocumentFormState
} from "./personProfileDocumentForm";

export type PersonProfileDocumentFieldsProps = {
  mode: "create" | "edit";
  form: PersonProfileDocumentFormState;
  onChange: (form: PersonProfileDocumentFormState) => void;
  categories: PersonProfileDocumentCategory[];
  currentCategory?: string;
  fileError?: string;
  onFileError?: (error: string) => void;
};

export default function PersonProfileDocumentFields({
  mode,
  form,
  onChange,
  categories,
  currentCategory,
  fileError = "",
  onFileError
}: PersonProfileDocumentFieldsProps) {
  const forcedPrivate = isMembershipServicesPrivateCategory(form.category);

  return (
    <div className="flex flex-col gap-6" data-testid="person-profile-document-fields">
      {mode === "create" && (
        <FileUpload
          label="Choose a file to upload"
          subtitle="Allowed file extensions: pdf, doc, docx, xls, xlsx, jpg, jpeg, png, txt"
          accept={ACCEPTED_PERSON_PROFILE_DOCUMENT_FILES}
          handleUpload={(file) => {
            onChange({
              ...form,
              file,
              name: form.name || filenameStem(file.name)
            });
            onFileError?.("");
          }}
          errorMsg={fileError}
          onError={onFileError}
          onClear={() => onChange({ ...form, file: null })}
        />
      )}
      <TextField label="Name" required value={form.name} onChangeText={(name) => onChange({ ...form, name })} />
      <TextField
        label="Description"
        value={form.description}
        onChangeText={(description) => onChange({ ...form, description })}
      />
      <Select
        label="Category"
        required
        data-testid="document-category-select"
        value={form.category}
        options={formCategoryOptions(categories, mode, currentCategory).map((option) => ({
          value: option.value,
          label: option.label
        }))}
        onSelect={(category) =>
          onChange({
            ...form,
            category,
            privacyRestricted: isMembershipServicesPrivateCategory(category) ? true : form.privacyRestricted
          })
        }
      />
      <Switch
        headline="Make Private"
        supportingText={
          forcedPrivate ? "Membership Services can open this file" : "Only your department can open the file"
        }
        selected={forcedPrivate || form.privacyRestricted}
        disabled={forcedPrivate}
        onChange={() => onChange({ ...form, privacyRestricted: !form.privacyRestricted })}
      />
    </div>
  );
}
